import React from "react";
import { Siren, Car, Wrench, Coins, Users, Map } from "lucide-react";

const FEATURES = [
    {
        icon: Siren,
        title: "Caçada Diária",
        body: "Sistema dinâmico de perseguições com NPCs e PCs. A cidade nunca dorme — sempre tem viatura no teu rabo.",
        span: "md:col-span-7",
        accent: true,
    },
    {
        icon: Car,
        title: "+150 Carros",
        body: "Frota tunada, exclusiva e sempre rolando. De cinquentinha até hipercarro.",
        span: "md:col-span-5",
    },
    {
        icon: Wrench,
        title: "Mecânica Avançada",
        body: "Tunagem real, dano por colisão, troca de peças e ajuste fino de suspensão.",
        span: "md:col-span-4",
    },
    {
        icon: Coins,
        title: "Economia do Submundo",
        body: "Lava o dinheiro do assalto, compra território, monta tua crew e domina o mercado preto.",
        span: "md:col-span-5",
        accent: true,
    },
    {
        icon: Users,
        title: "Crews & Famílias",
        body: "Crie sua organização. Domine territórios. Faça guerra.",
        span: "md:col-span-3",
    },
    {
        icon: Map,
        title: "Mapa Estendido",
        body: "Mods de mapa exclusivos. Túneis, drift spots e rotas de fuga secretas.",
        span: "md:col-span-12",
    },
];

export default function Features() {
    return (
        <section
            id="features"
            data-testid="features-section"
            className="relative py-24 md:py-40 bg-[#0D0D0D]"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-12 bg-neon-yellow" />
                            <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                                ▸ O que rola aqui
                            </span>
                        </div>
                        <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tighter leading-none">
                            Recursos
                            <br />
                            <span className="text-neon-yellow">na pista</span>
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md text-base md:text-lg">
                        Sistemas próprios, scripts customizados e zero copy-paste.
                        Aqui é diferente, e tu vai sentir na primeira esquina.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {FEATURES.map((f, i) => {
                        const Icon = f.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`feature-card-${i}`}
                                className={`${f.span} group relative p-8 md:p-10 border ${
                                    f.accent
                                        ? "bg-neon-yellow text-black border-neon-yellow"
                                        : "bg-[#141414] text-white border-white/10 hover:border-neon-yellow"
                                } transition-colors`}
                            >
                                <Icon
                                    size={40}
                                    strokeWidth={1.5}
                                    className={
                                        f.accent
                                            ? "text-black mb-6"
                                            : "text-neon-yellow mb-6"
                                    }
                                />
                                <h3 className="font-heading text-3xl md:text-4xl uppercase tracking-tight mb-3 leading-none">
                                    {f.title}
                                </h3>
                                <p
                                    className={`${
                                        f.accent
                                            ? "text-black/80"
                                            : "text-white/60"
                                    } text-base leading-relaxed max-w-md`}
                                >
                                    {f.body}
                                </p>

                                <span
                                    className={`absolute top-4 right-4 font-mono text-[10px] uppercase tracking-[0.2em] ${
                                        f.accent
                                            ? "text-black/60"
                                            : "text-white/30"
                                    }`}
                                >
                                    0{i + 1} /
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
